import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message, cancelText = "Annuler", confirmText = "Confirmer" }) => {
  if (!isOpen) return null;

  // Empêcher la propagation du clic sur le contenu du modal
  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="confirmation-modal-overlay" onClick={onClose}>
      <div className="confirmation-modal-content" onClick={handleContentClick}>
        <div className="confirmation-modal-header">
          <h3>{title}</h3>
          <button className="close-modal-btn" onClick={onClose}>&times;</button>
        </div>
        
        <div className="confirmation-modal-body">
          {typeof message === 'string' ? <p>{message}</p> : message}
        </div>
        
        <div className="confirmation-modal-footer">
          <button className="btn btn-outline" onClick={onClose}>{cancelText}</button>
          <button className="btn btn-danger" onClick={onConfirm}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;